import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { Chargeback } from '../models/chargeback.model';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
@Injectable({ providedIn: 'root' })
export class ChargebackService {
    private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
        bank: environment.apiBankUrl, 
        pgl: environment.apiPglUrl,
        smt: environment.apiSmtUrl,
      };
      private getBaseUrl(): string {
        const userType = this.getUserType();
        return this.apiUrls[userType??'smt'];
      }
      private getUserType(): 'bank' | 'pgl' | 'smt' {
        const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
        if (!token) return 'smt';
    
        try {
          const decodedToken: any = jwtDecode(token);
          return decodedToken.type as 'bank' | 'pgl' | 'smt';
        } catch (error) {
          console.error('Error decoding token:', error);
          return 'smt';
        }
      }
    
    constructor(private http: HttpClient) { }
    public chargebacks: Chargeback[] = [];
    public chargebacks$ = new Subject<Chargeback[]>();
 
    create(chargeback: Chargeback) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();
        this.http.post(`${baseUrl}/chargeback/`, chargeback).subscribe(
          (response) => {
            resolve(response);

          },
          (error) => {
            reject(error);
          },
        );
      });
    }
    getchargebacks() {
            return new Promise((resolve, reject) => {
              const baseUrl = this.getBaseUrl();
                this.http.get(`${baseUrl}/chargeback/`).subscribe(
                  (response) => {
                    resolve(response);
                  },
                  (error) => {
                    reject(error); 
                  }
                );
              });
      }
      getnewchargebacks() {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/chargeback/new/`).subscribe(
              (response) => {
                resolve(response);
              },
              (error) => {
                reject(error); 
              }
            );
          });
  }
    /*  emitchargebacks() {
        this.chargebacks$.next(this.chargebacks);
      }*/
      getchargebackById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.get(`${baseUrl}/chargeback/new/${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error); 
            }
          );
        });
      }
   /* geexistenttmotifreclamation(userId: string,annee:string,mois:string,source:string) 
    {
return new Promise((resolve, reject) => {
        this.http.post(API_URL_cloud+'/anneemois/',{userId,annee,mois,source}).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error); 
          }
        );
      });

      }*/
      
    /*  create(motifreclamation: Motif) {
        return new Promise((resolve, reject) => {
          
          this.http.post(API_URL_cloud, motifreclamation).subscribe(
            (response) => {
              resolve(response);

            },
            (error) => {
              reject(error);
            },
          );
        });
      }*/
    
     
    
     /* modify(id: string, motifreclamationreq: Motif, image: File | string) {
        return new Promise((resolve, reject) => {
          let motifreclamationreqData: Motif | FormData;
          if (typeof image === 'string') {
            
            motifreclamationreqData = motifreclamationreq;
          } else {
            motifreclamationreqData = new FormData();
            motifreclamationreqData.append('motifreclamationreq', JSON.stringify(motifreclamationreq));
            motifreclamationreqData.append('image', image, motifreclamationreq.email);
          }
          this.http.put(API_URL_cloud + id, motifreclamationreqData).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }*/
     update(id: string, chargeback: Chargeback) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.put(`${baseUrl}/chargeback/${id}`, chargeback).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }
    
      deletechargebackById(id: string) {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}/chargeback/${id}`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }  
      deletechargebacks() {
        return new Promise((resolve, reject) => {
          const baseUrl = this.getBaseUrl();
          this.http.delete(`${baseUrl}/chargeback/`).subscribe(
            (response) => {
              resolve(response);
            },
            (error) => {
              reject(error);
            }
          );
        });
      }
    }
